import { useIsMobile } from "./ui/use-mobile";

interface BackgroundMediaProps {
  videoSrc: string;
  imageSrc: string;
  className?: string;
  style?: React.CSSProperties;
  objectPosition?: string;
}

/**
 * 背景媒体组件
 * 手机端显示静态图片，电脑端显示视频
 */
export function BackgroundMedia({
  videoSrc,
  imageSrc,
  className = "w-full h-full object-cover",
  style,
  objectPosition,
}: BackgroundMediaProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    // 手机端显示图片
    return (
      <img
        src={imageSrc}
        alt="Background"
        className={className}
        style={{ ...style, objectPosition: objectPosition || style?.objectPosition }}
      />
    );
  }

  // 电脑端显示视频
  return (
    <video
      src={videoSrc}
      autoPlay
      muted
      loop
      playsInline
      className={className}
      style={{ ...style, objectPosition }}
    />
  );
}

